export const VENDOR_TERM_LINK = 'mac/FETCH_VENDOR_TERM_LINK';
